@if (showSidePanel) {
  <div class="flex items-center justify-end mb-2 mr-2">
    <label class="font-bold mr-2">Incomplete Only</label><app-toggle-switch [(checked)]="filterQuestions"></app-toggle-switch>
  </div>
}
<div
  class="bg-navigation-surface py-5 rounded-tl-2xl rounded-bl-2xl pl-5 pr-4 ml-5 shadow-[1.0px_8.0px_8.0px_rgba(0,0,0,0.38)] transition-all duration-700 ease-in flex flex-col max-h-full">

  <div (click)="switchShowSidePanel()" class="flex ">
    <span class="material-symbols-outlined hover:cursor-pointer">menu</span>
    @if (showSidePanel) {
      <h4 class="text-green-700 font-bold ml-2">
        Contents
      </h4>
    }
  </div>

  @if (showSidePanel) {
    <div class="mt-2 flex-grow overflow-y-auto">
      <ul class="striped-list rounded-sm">
        @for (e of filteredQuestions(); track e) {
<li [ngClass]="{
          highlighted: e.CompletionInfo.QuestionAnswered || e.NASelected,
          title: e.QuestionType.ID == 6,
          'text-grey-500 hover:cursor-not-allowed':e.BranchedOut,
          ' hover:cursor-pointer':!e.BranchedOut,
          'border-l-4 border-l-danger-base ':summaryDisplayed && !e.BranchedOut && ((!e.CompletionInfo.QuestionAnswered && e.Required && !e.NASelected) || (e.CompletionInfo.QuestionAnswered && e.CompletionInfo.NonCompliant && e.CompletionInfo.Actions.length == 0 && !e.NASelected)),
          'border-b-2 border-b-offblack':e.IsRepeatEnd,
          'mt-1':e.IsRepeatStart
        }" class="px-2 py-1 my-[1px]"  (click)="jumpToQuestion(e.GUID,e.BranchedOut)">
            <p class="text-sm">{{ e.QuestionHeader }}</p>
          </li>
        }
      </ul>
    </div>
  }
  @if (this.currentQuestions.length > 0 && showSidePanel) {
    <button class="btn-primary w-full mt-4"
      (click)="goToSummary()">
      Finish
    </button>
  }
</div>
